import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import ReferensiSvc from "@/services/Referensi";

interface InHolidaysItem {
  date: string;
  note: string;
}

interface CaraKeluarItem {
  id: string | number;
  nama: string;
  label: string;
  value: string;
}

@Module({ dynamic: true, namespaced: true, store, name: "master-referensi" })
class MasterReferensi extends VuexModule {
  caraKeluar: CaraKeluarItem[] = [];
  holidays: InHolidaysItem[] = [];

  @Mutation
  SET_CARA_KELUAR(data: CaraKeluarItem[]) {
    this.caraKeluar = data;
  }

  @Action({ rawError: true })
  async getCaraKeluarList() {
    const resp = await ReferensiSvc.getCaraKeluarList();

    this.SET_CARA_KELUAR(resp);
  }

  @Mutation
  SET_HOLIDAYS(val: InHolidaysItem[]) {
    this.holidays = val;
  }

  @Action({ rawError: true })
  async getHolidays(): Promise<void> {
    const response = await ReferensiSvc.getHolidays();

    this.SET_HOLIDAYS(response);
  }

  @Action({ rawError: true })
  async clearData(): Promise<void> {
    this.SET_HOLIDAYS([]);
  }
}

export default getModule(MasterReferensi);
